import styled from 'styled-components';
import { appTheme } from '../../theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 8px;
  overflow: hidden;
`;

export const ActivityCard = styled.div`
  max-width: 75%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  width: 100%;
  border-bottom: 1px solid ${appTheme.background};

  &:last-child {
    border-bottom: none;
  }
`;

export const ActivityTitle = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: ${appTheme.title};
  margin-right: 12px;
`;

export const ActivityDistance = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #FFFFFF;
`;
